import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AuthGuard from "./auth/AuthGuard";
import AuthHandler from "./auth/AuthHandler";
import PageTracker from "./components/Analytics/PageTracker";

import Loading from "./Loading";

const LazyErrorPage = React.lazy(() => import("./404"));
const LazySplash = React.lazy(() => import("./pages/splash/Splash"));
const LazySubscriptionRequired = React.lazy(() => import("./pages/subscription/SubscriptionRequired"));
const LazyCodeNexusDeviceAuthorization = React.lazy(() => import("./pages/auth/CodeNexusDeviceAuthorization"));

import Interface from "./pages/interface/App";

const AppRoutes = () => {
    return (
        <Suspense fallback={<Loading />}>
            <PageTracker />
            <Routes>
                <Route path="/" element={<Navigate to="/splash" replace />} />
                <Route path="/splash" element={<LazySplash />} />
                <Route path="/auth" element={<AuthHandler />} />
                <Route path="/subscription-required" element={<LazySubscriptionRequired />} />
                <Route path="/codenexus/device" element={<LazyCodeNexusDeviceAuthorization />} />
                <Route
                    path="/dashboard/*"
                    element={
                        <AuthGuard>
                            <Interface />
                        </AuthGuard>
                    }
                ></Route>
                {/* The interface navigates state-first and writes URLs like
                    /products/new via raw history.pushState, which React Router
                    never sees in-session. These routes make those URLs
                    reload-safe: Interface derives the view from the pathname
                    (viewForPath) on mount. */}
                <Route
                    path="/products/*"
                    element={
                        <AuthGuard>
                            <Interface />
                        </AuthGuard>
                    }
                ></Route>
                <Route path="*" element={<LazyErrorPage />} />
            </Routes>
        </Suspense>
    );
};

export default AppRoutes;
